import React from "react";
import toLower from "lodash/toLower";
import { withTranslation } from "react-i18next";

import submit from "submit-form";
import { S3 } from "../../../../constants";
import Modal from "../../../../parts/modal-new";
import SvgIcon from "../../../../parts/SvgIcon";
import ChooseCoach from "../../../dashboard/settings/manage-coaches/ChooseCoach";
import {
  getDefaultAssignedCoach,
  getUsersAssignableAsCoach,
} from "../../../dashboard/settings/manage-coaches/utils/manage-coaches-utils";
import { RillContext } from "../../../../rill/RillReact/share/base";

const isValidEmail = (email) => {
  var re =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

class InviteAthleteModal extends React.PureComponent {
  constructor(props, context) {
    super(props, context);
    this.state = {
      canCheckEmail: false,
      checkedEmail: "",
      email: "",
      submited: false,
      editing: true,
      selectedOrganizationCoach: this.getDefaultCoach(),
    };
  }

  getDefaultCoach() {
    const { activeUser, usersOrganization } = this.context.locals;
    return getDefaultAssignedCoach(
      activeUser,
      usersOrganization?.organizationActiveUsers
    );
  }

  handleEmailInput({ target: { name, value } }) {
    if (isValidEmail(value)) {
      this.setState((prevState) => {
        return Object.assign({}, prevState, {
          canCheckEmail: true,
          [name]: value,
          checkedEmail: "",
        });
      });
    } else {
      this.setState((prevState) => {
        return Object.assign({}, prevState, {
          canCheckEmail: false,
          [name]: value,
          checkedEmail: "",
        });
      });
    }
  }

  checkEmail(e) {
    const email = this.state.email;
    submit(`/actions/refresh`, {
      method: "GET",
      body: {
        email: toLower(email),
      },
    });

    this.setState((prevState) =>
      Object.assign(
        {},
        { canCheckEmail: true, checkedEmail: email, email: "", editing: false }
      )
    );

    return false;
  }

  checkOtherEmail(e) {
    submit(`/actions/refresh`, {
      method: "GET",
      body: {
        email: "",
      },
    });

    this.setState((prevState) =>
      Object.assign(
        {},
        {
          canCheckEmail: false,
          checkedEmail: "",
          email: "",
          submited: false,
          selectedOrganizationCoach: this.getDefaultCoach(),
        }
      )
    );
  }

  selectOrganizationCoach = (e, coach) => {
    this.setState((prevState) => ({
      selectedOrganizationCoach: coach,
    }));
  };

  sendInvite(e, isExisting, googlePlayLink, appStoreLink) {
    const activeUser = this.context.locals.activeUser;
    const organizationOwner = this.context.locals.organizationOwner;
    const activeUserToRequest = this.context.locals.activeUserToRequest;
    //this endpoint is in the athletes.controller
    if (this.state.submited) return;
    let body = {
      email: this.state.checkedEmail,
      isExisting,
      googlePlayLink,
      appStoreLink,
    };
    if (activeUser.organizationId && activeUserToRequest) {
      const businessName = activeUserToRequest.businessName
        ? activeUserToRequest.businessName
        : activeUserToRequest.name;
      const organizationCoachId = this.state.selectedOrganizationCoach._id;
      body = {
        ...body,
        businessName,
        organizationCoachId,
        ...(organizationOwner && {
          organizationOwnerId: organizationOwner._id,
        }),
      };
    }
    submit(`/coaching-portal/athletes/invite-athlete`, {
      method: "POST",
      body,
    });
    this.setState({ submited: true });
  }

  render() {
    const { canCheckEmail, checkedEmail, selectedOrganizationCoach, editing } =
      this.state;
    const { existingUser, t } = this.props;
    const {
      query,
      activeUserToRequest,
      usersOrganization = {
        organizationActiveUsers: [],
      },
      activeUser,
    } = this.context.locals;
    const { organizationActiveUsers = [] } = usersOrganization;

    const referAsClients = Boolean(activeUser.referAsClients);
    const roleInvite = referAsClients
      ? t("athletes.roleArticleClient")
      : t("athletes.roleArticleAthlete");
    const roleTitle = referAsClients
      ? t("athletes.roleClient")
      : t("athletes.roleAthlete");
    const googlePlayLink =
      activeUserToRequest.appStoreListingEnable &&
      activeUserToRequest.googlePlayLink
        ? activeUserToRequest.googlePlayLink
        : "https://play.google.com/store/apps/details?id=com.mystrengthbook&hl=en_US&gl=US&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1";
    const appStoreLink =
      activeUserToRequest.appStoreListingEnable &&
      activeUserToRequest.appStoreLink
        ? activeUserToRequest.appStoreLink
        : "https://apps.apple.com/us/app/mystrengthbook/id1337179045";
    return (
      <Modal
        toClear={["email"]}
        className="invite-athlete-modal"
        title={t("athletes.inviteAthleteModal.title", { role: roleTitle })}
      >
        <div className="body">
          {!checkedEmail && (
            <>
              <div className="chip info">
                {t("athletes.inviteAthleteModal.inviteHint", {
                  role: roleInvite,
                })}
              </div>
            </>
          )}
          {!!checkedEmail && (
            <>
              {!existingUser && (
                <>
                  <div className="chip info">
                    {t("athletes.inviteAthleteModal.emailNotInDb")}
                  </div>
                </>
              )}

              {!!existingUser && (
                <>
                  <div className="chip success">
                    {t("athletes.inviteAthleteModal.userFoundInDb")}
                  </div>
                  <div>
                    <article>
                      <div
                        data-default={
                          existingUser.avatar && existingUser.avatar.s3Path
                            ? undefined
                            : true
                        }
                      >
                        {existingUser.avatar && existingUser.avatar.s3Path ? (
                          <img
                            src={`${S3.PATH}${existingUser.avatar.s3Path}`}
                            alt={t(
                              "athletes.inviteAthleteModal.profilePictureAlt",
                              { name: existingUser.name }
                            )}
                            loading="lazy"
                          />
                        ) : (
                          <SvgIcon src="/img/svg/user-circle.svg" />
                        )}
                      </div>
                      <div>
                        <p>
                          <strong>{existingUser.name}</strong>
                        </p>
                        <p>{existingUser.email}</p>
                      </div>
                    </article>
                  </div>
                </>
              )}
            </>
          )}
          <search>
            <label for="name">
              {t("athletes.inviteAthleteModal.emailLabel")}
            </label>
            <input
              autoFocus={true}
              name="email"
              type="text"
              className=""
              placeholder={t("athletes.inviteAthleteModal.enterEmailPlaceholder")}
              onChange={(e) => this.handleEmailInput(e)}
              disabled={!editing}
            />
            {canCheckEmail && (
              <div className="input-controls">
                {checkedEmail && (
                  <SvgIcon
                    role="button"
                    data-button-type="text-white"
                    data-icon
                    data-icon-only
                    sz="small"
                    src={"/img/new-icons/edit-pencil.svg"}
                    onClickFn={() =>
                      this.setState({ editing: true, checkedEmail: "" })
                    }
                  />
                )}
                {!checkedEmail && (
                  <button
                    href={"#_"}
                    onClick={(e) => (canCheckEmail ? this.checkEmail(e) : null)}
                    data-button-type="text"
                  >
                    <p className="clipped z-10">
                      {t("athletes.inviteAthleteModal.check")}
                    </p>
                  </button>
                )}
              </div>
            )}
          </search>
          {!!checkedEmail && !existingUser && activeUser.organizationId && (
            <>
              <label>
                {t("athletes.inviteAthleteModal.assignCoach")}
              </label>
              <ChooseCoach
                activeUser={activeUser}
                organizationActiveUsers={getUsersAssignableAsCoach(
                  organizationActiveUsers
                )}
                onSelectCoach={this.selectOrganizationCoach}
                selectedCoach={selectedOrganizationCoach}
              />
            </>
          )}
        </div>
        <footer className="footer-invite-modal">
          <button
            onClick={(e) =>
              this.sendInvite(e, !!existingUser, googlePlayLink, appStoreLink)
            }
            data-button-type="primary"
            disabled={!checkedEmail}
          >
            {" "}
            {t("athletes.inviteAthleteModal.invite")}
          </button>
        </footer>
      </Modal>
    );
  }
}

InviteAthleteModal.contextType = RillContext;

export default withTranslation("coaching-portal")(InviteAthleteModal);
